<template>
    <div class="position-relative">
        <!-- Begin Page Content -->
        <div class="medical-records">
            <div class="row">
                <div class="col-12 mb-4 register-connect">
                    <div class="bg-white border-radius-5 p-5">
                        <div class="card border-0">
                            <div class="card-body p-0">
                                <div class="row justify-content-center pt-3">
                                    <div class="col-md-6 text-center">
                                        <h2>Register Your kit</h2>
                                        <div class="register">
                                            <img src="../../../../static/website/images/logo.svg" class="logo" alt="logo" />
                                        </div>
                                        <h4 class="mt-4 mb-3 text-left mb-0">What is Your DN kit barcode?</h4>
                                        <div class="Gini-Health px-4 py-3 mb-5 bg-body border-radius-5 text-left mb-0">
                                            <p>X000000000</p>
                                        </div>
                                        <div class="need-help text-center">
                                            <h3>Need Help?</h3>
                                            <ul class="form mb-0 text-left">
                                                <li class="input-group d-flex justify-content-between mb-4 px-4 py-3 mb-3 bg-body border-radius-5 text-left">
                                                    <span>Where do I find my barcode?</span> <i class="icon icon-chevron-down"></i>
                                                </li>
                                                <li class="input-group d-flex justify-content-between mb-4 px-4 py-3 mb-3 bg-body border-radius-5 text-left">
                                                    <span>I’m still waiting for my kit?</span> <i class="icon icon-chevron-down"></i>
                                                </li>
                                                <li class="input-group d-flex justify-content-between mb-4 px-4 py-3 mb-3 bg-body border-radius-5 text-left">
                                                    <span>I don’t have my kit anymore? </span> <i class="icon icon-chevron-down"></i>
                                                </li>
                                            </ul>
                                        </div>
                                        <router-link class="btn btn-blue dna-gini-button mt-2" to="/dna-test-report">Connect my DNA</router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- End of Page Wrapper -->
</template>
<script>
    export default {
        name: "register-kit",
        data() {
            return {};
        },
        created(){
           this.pageName('Register Your kit')
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/website/test_report/register-kit.vue